module.exports = __webpack_public_path__ + "static/media/pawritten.3e28397a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten.ttf
// module id = ./src/assets/fonts/pawritten.ttf
// module chunks = 0